//@ts-strict-ignore
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import { PickingInstruction } from '../../graphql/entities';
import { default as normalizeVariables, normalizeFields } from '../../graphql/schema/normalizeVariables';
import getIn from '../../components/connectedForm/utils/getIn';
import { getRangeMutationProps } from './DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import { IConnectedFormModalProps } from '../../components/Context/ConnectedFormContext';

function onComplete(state, props: IConnectedFormModalProps & any, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onProcessSummary, onComplete: onCompleteFromProps, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Picking Instruction',
    documentNamePlural: 'Picking instructions',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
    onComplete: onCompleteFromProps,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;

  let mutation = PickingInstruction.generate!;

  if (props.generateSingle) {
    mutation = PickingInstruction.generateSingle!;
    variables.salesOrder = normalizeVariables(getIn(props, 'values'));
    variables.reset = !!state.reset;
  } else {
    variables.allocationSalesHelperContainer = normalizeVariables(getIn(props, 'values'), [
      ...normalizeFields,
      'allocationSalesHelperStock',
    ]);
  }

  createBackgroundJob(mutation, variables, props, returnUrl, 'Generate Picking Instruction', (job) =>
    onComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    PickingInstruction.generateRange!,
    getRangeMutationProps(state, props, variables, 'salesOrders'),
    props,
    returnUrl,
    'Generate Picking Instruction',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

/**
 * Reprints a set of picking instructions (Provided as an array within variables).
 */
export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    PickingInstruction.reprintRange!,
    getRangeMutationProps(state, props, variables, 'pickingInstructions'),
    props,
    returnUrl,
    'Generate Picking Instructions',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}
